import {createRoot, hydrateRoot} from 'react-dom/client';
import OurProcess from '../pages/OurProcess/OurProcess'
import "../index.css";
import "../pages/OurProcess/OurProcess.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<OurProcess {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <OurProcess {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).OurProcessVC = {mount, hydrate, unmount}